import { gql } from '@apollo/client';

export const importTrucks = gql`
	mutation importTrucks($csvFile: Upload!) {
		importTrucks(csvFile: $csvFile) {
			ok
			message
			response
		}
	}
`;
